import classNames from 'classnames';

export const ProbabilityBtn = ({ isOrangeType = false }: { isOrangeType?: boolean }) => {
    return (
        <button
            className={classNames({
                'probability-button__gem': isOrangeType,
                'probability-button': !isOrangeType,
            })}
            data-tooltip-id={isOrangeType ? undefined : 'my-tooltip_probability-button'}
        >
            확률적
        </button>
    );
};
